import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import queryString from 'query-string';

import {
  dispatchSelectTimesheetDate,
  dispatchSelectUserId,
  dispatchSelectTimeEntryDate,
  setShowTerminatedUsers,
} from './actions';

import TimesheetNavigationPanelEnhanced from './containers/TimesheetNavigationPanelEnhanced';
import TimesheetFilteringPanel from './containers/TimesheetFilteringPanel';
import { routerProps } from '../../propTypes';

import PageLayout from '../../layouts/PageLayout';
import SplitLayout from '../../layouts/SplitLayout';
import { toCentralTime } from '../../utils';


const propTypes = exact({
  dispatchSelectUserIdAction: PropTypes.func.isRequired,
  dispatchSelectTimesheetDateAction: PropTypes.func.isRequired,
  dispatchSelectTimeEntryDateAction: PropTypes.func.isRequired,
  setShowTerminatedUsersAction: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,

  ...routerProps,
});

const TimesheetNavigator = (props) => {
  return (
    <PageLayout
      title="Timesheet Viewer"
      render={() => {
        return (
          <SplitLayout
            leftSize={2}
            leftRender={() => { return (<TimesheetFilteringPanel />); }}
            rightSize={10}
            rightRender={() => { return (<TimesheetNavigationPanelEnhanced />); }}
          />
        );
      }}
    />
  );
};

TimesheetNavigator.propTypes = propTypes;

const withInitPage = lifecycle({
  componentWillMount() {
    const {
      location,
      dispatchSelectUserIdAction,
      dispatchSelectTimesheetDateAction,
      dispatchSelectTimeEntryDateAction,
      setShowTerminatedUsersAction,
    } = this.props;
    const querySringObject = queryString.parse(location.search);
    const { userId, originDate, timeEntryDate, showTerminated } = querySringObject;

    const userIdValue = parseInt(userId, 10);

    if (userId && !Number.isNaN(userIdValue)) {
      dispatchSelectUserIdAction(userIdValue);
    }

    /* NOTE: Date.parse returns number of milliseconds, if not date returns NaN */
    if (!Number.isNaN(Date.parse(timeEntryDate))) {
      const dateObj = toCentralTime(timeEntryDate).toDate();
      dispatchSelectTimeEntryDateAction(dateObj);
    }

    if (!Number.isNaN(Date.parse(originDate))) {
      const dateObj = toCentralTime(originDate).toDate();
      dispatchSelectTimesheetDateAction(dateObj);
    }

    if (showTerminated === 'false' || showTerminated === 'true') {
      const boolValue = (showTerminated === 'true');
      setShowTerminatedUsersAction(boolValue);
    }
  },
});

const mapDispatchToProps = {
  dispatchSelectUserIdAction: dispatchSelectUserId,
  dispatchSelectTimesheetDateAction: dispatchSelectTimesheetDate,
  dispatchSelectTimeEntryDateAction: dispatchSelectTimeEntryDate,
  setShowTerminatedUsersAction: setShowTerminatedUsers,
};

const withRedux = connect(null, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withInitPage,
);

export default enhance(TimesheetNavigator);
